import { useEffect, useMemo, useState } from "react";

import { useParams } from "react-router-dom";

import api, { handleApi } from "pages/api/api";
import { useAlert } from "pages/context/AlertContext";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import PageHeader from "pages/components/PageHeader";
import MaterialDetalheCabecalho from "pages/materiais/MaterialDetalheCabecalho";
import MaterialDetalheConteudo from "pages/materiais/MaterialDetalheConteudo";

import MDBox from "components/MDBox";

import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import Divider from "@mui/material/Divider";

export default function MaterialDetalhe() {
  const { refmaterial } = useParams();
  const { showAlert } = useAlert();

  const [loading, setLoading] = useState(true);
  const [material, setMaterial] = useState(null);

  const refMaterialAtual = useMemo(
    () => decodeURIComponent(String(refmaterial || "")).trim(),
    [refmaterial]
  );

  useEffect(() => {
    let active = true;

    const carregar = async () => {
      if (!refMaterialAtual) {
        setMaterial(null);
        setLoading(false);
        return;
      }

      setLoading(true);
      setMaterial(null);

      const [dados, err] = await handleApi(
        api.post("Materiais/SelCabecalhoMaterial", {
          refmaterial: refMaterialAtual,
        })
      );

      if (!active) return;

      setLoading(false);

      if (err) {
        showAlert(err, "error");
        setMaterial(null);
        return;
      }

      setMaterial({
        ...(dados || {}),
        ref: String(dados?.refmaterial || refMaterialAtual).trim(),
        refmaterial: String(dados?.refmaterial || refMaterialAtual).trim(),
        nome: String(dados?.nomematerial || dados?.nome || "").trim(),
        nomematerial: String(dados?.nomematerial || dados?.nome || "").trim(),
      });
    };

    carregar();

    return () => {
      active = false;
    };
  }, [refMaterialAtual, showAlert]);

  useEffect(() => {
    const limitar = (texto, max = 40) => {
      texto = String(texto || "").trim();

      if (texto.length <= max) return texto;

      return `${texto.substring(0, max - 3).trim()}...`;
    };

    if (material) {
      const ref = String(material.refmaterial || material.ref || "").trim();
      const nome = limitar(material.nomematerial || material.nome || "", 40);

      document.title = nome ? `${ref} - ${nome}` : ref;
    } else if (refMaterialAtual) {
      document.title = refMaterialAtual;
    }

    return () => {
      document.title = "JF Bebidas";
    };
  }, [material, refMaterialAtual]);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {loading ? (
        <MDBox mt={1} mb={1} display="flex" alignItems="center" justifyContent="center">
          <CircularProgress size={24} />
        </MDBox>
      ) : null}

      <PageHeader />

      <MDBox mt={3}>
        <Card>
          {!loading && material ? (
            <>
              <MaterialDetalheCabecalho material={material} ativo />

              <Divider sx={{ m: 0 }} />

              <MaterialDetalheConteudo material={material} centrosSelecionados={[]} ativo />
            </>
          ) : null}

          {!loading && !material ? (
            <MDBox px={3} py={3} fontSize="small" color="text">
              Não foi possível encontrar o material indicado.
            </MDBox>
          ) : null}
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}
